import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';
import { Company, UserGroup } from './models';

export class User extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'users';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      first_name: this.attr(null),
      last_name: this.attr(null),
      // name: this.attr(null),
      email: this.attr(null),
      password: this.attr(null),
      phone_mobile: this.attr(null),
      phone_office: this.attr(null),
      is_activated: this.attr(false),
      group_code: this.attr(null),
      group: this.belongsTo(UserGroup, 'group_code', 'code'),
      company_id: this.attr(null),
      company: this.belongsTo(Company, 'company_id'),
      notes: this.attr(null),
      password_confirmation: this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }

  get name() {
    return [this.first_name, this.last_name].join(' ');
  }
}

export default User;
